import React from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IOSSwitch from 'components/IOSSwitch';
import classnames from 'classnames';
import styles from './styles';

export const onDSLogin = (e) => {
  const callbackUrl = `${window.location.origin}/home`;
  const testLink =
    `${process.env.REACT_APP_DOCUSIGN_PATH}/oauth/auth?response_type=code&scope=impersonation%20signature` +
    `&client_id=${process.env.REACT_APP_DOCUSIGN_API_INTEGRATION_KEY}&redirect_uri=${callbackUrl}`;
  window.open(testLink);
};

const WorkShifts = ({ classes }) => {
  return (
    <Grid container item alignItems="center" className={classes.workShiftBlock}>
      <Grid item xs={12} md={6}>
        <Typography variant="h4">Shifts</Typography>
      </Grid>
    </Grid>
  );
};

WorkShifts.propTypes = {
  classes: propTypes.object.isRequired,
  handleChangeScheduleNotifications: propTypes.func.isRequired,
};

export default withStyles(styles)(WorkShifts);
